import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './effects';
import { SnackbarPersistenceService } from './services/snackbar-state-persistence.service';

export function snackbarStatePersistenceFactory(snackbarPersistenceService: SnackbarPersistenceService): () => void {
  return () => snackbarPersistenceService.sync();
}

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = snackbarStatePersistenceFactory(inject(SnackbarPersistenceService));

      return initializerFn();
    }),
  ],
})
export class MainSnackbarFeatureModule {}
